// libraries
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import Lottie from "react-lottie-player";

// components
import { InViewAnimation, OldRibbon, Pill } from "..";

// assets
import BrokenImg from "src/assets/images/home/gradient.png";
import * as ButtonAnim from "src/assets/lottie/button.json";
import * as FireIconAnim from "src/assets/lottie/fireicon.json";

// utils
import { convertToSlug } from "src/utils/helpers";

// icons
import {
  LocationIcon,
  WalkIcon,
  TimeIcon,
  CalenderFill,
  Video,
} from "src/assets/icons";
import { FaPhoneAlt } from "react-icons/fa";

// styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const EventItem = ({ data, classname }) => {
  const [playAnim, setPlayAnime] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [ribbonTag, setRibbonTab] = useState({
    label: null,
    isNew: false,
  });

  useEffect(() => {
    if (data) {
      if (data.isNew !== "1")
        setRibbonTab({
          label: "New Event",
          isNew: true,
        });
      else if (data.isNew !== "1" && data.isTrending === "1") {
        setRibbonTab({
          label: "Trending",
          isNew: false,
        });
      }
    }
  }, [data]);

  const getSlug = () => {
    if (Object.entries(data).length > 0) {
      let slug = convertToSlug(data.name);
      return `/${slug}/${data.id}/${data.timeId}`;
    }

    return "#";
  };

  const isNow = () => {
    return data.startTime === "Happening Now";
  };

  const showTime = () => {
    if (data.startTime === undefined) return false;
    else if (
      data?.callToBook !== undefined &&
      data?.callToBook === "call to book"
    )
      return false;

    return true;
  };

  const handleNotify = (e) => {
    e.preventDefault();
    setPlayAnime(true);
  };

  if (!data.id) {
    return <SkeletonComponent />;
  }

  return (
    <div className={cx("event-item-root", classname)}>
      <Link to={getSlug()}>
        <div className={cx("img-wrapper")}>
          <img
            src={!imgError ? data.image : BrokenImg}
            alt={data.name}
            className={cx("main-image")}
            onError={() => setImgError(true)}
          />
          <Pill label={data?.category || ""} classname={cx("pill-wrapper")} />
          {ribbonTag.label === "New Event" && (
            <OldRibbon
              label={
                <>
                  <div className={cx("glow")}></div>
                  New Event
                </>
              }
              classname={cx("new-event-wrapper")}
            />
          )}
          {ribbonTag.label === "Trending" && (
            <InViewAnimation
              hiddenProps={{ y: 5, opacity: 0 }}
              visibleProps={{ y: 0, opacity: 1 }}
              transitionProps={{ duration: 0.35, delay: 0.5 }}
            >
              <Pill
                label={
                  // <span>
                  //   <FireIcon /> Trending
                  // </span>
                  <span>
                    <Lottie
                      loop
                      animationData={FireIconAnim}
                      play
                      className={cx("fire-icon")}
                    />
                    Trending
                  </span>
                }
                classname={cx("trending-wrapper")}
              />
            </InViewAnimation>
          )}
        </div>
        <div className={styles.wrap}>
          <div className={cx("row", "hidden")}>
            <span className={cx("category")}>{data?.category}</span>
            <div className={cx("wrapper", { now: isNow() })}>
              <TimeIcon />
              <span className={cx("time")}>{data?.startTime}</span>
            </div>
          </div>
          {/* {data?.callToBook === "call to book" && (
            <div className={cx("contact")}>
              <FaPhoneAlt />
              <span className={cx("time")}>Contact for time</span>
            </div>
          )} */}
          <h1>{data.name}</h1>
          <div className={cx("content")}>
            {/* {showTime() && (
              <div className={cx("icon-wrapper", "calender")}>
                <span className={cx("icon")}>
                  <CalenderFill />
                </span>
                <span className={cx("label")}>{data.startTime}</span>
              </div>
            )} */}
            <div className={cx("icon-wrapper", "calender")}>
              <span className={cx("icon")}>
                <CalenderFill />
              </span>
              {data?.callToBook === "call to book" ? (
                <span className={cx("label")}>Contact for time</span>
              ) : (
                <span className={cx("label")}>{data.startTime}</span>
              )}
            </div>

            <div className={cx("group")}>
              <div className={cx("icon-wrapper", "location")}>
                <span className={cx("icon")}>
                  <LocationIcon />
                </span>
                <span className={cx("label")}>{data.location}</span>
              </div>
              {/* <Lottie
                loop={false}
                animationData={ButtonAnim}
                play={playAnim}
                className={cx("lottie-btn")}
                onClick={(e) => handleNotify(e)}
              /> */}
            </div>

            {data?.isVirtual === "0" ? (
              <div className={cx("icon-wrapper", "walk")}>
                <span className={cx("icon")}>
                  <WalkIcon />
                </span>
                <span className={cx("label")}>
                  {data.distance} mile(s) away
                </span>
              </div>
            ) : (
              <div className={cx("icon-wrapper")}>
                <span className={cx("icon")}>
                  <Video />
                </span>
                <span className={cx("label")}>online event</span>
              </div>
            )}
          </div>
        </div>
        {/* <Lottie
          loop={false}
          animationData={ButtonAnim}
          play={playAnim}
          className={cx("lottie-btn-abs")}
          onClick={(e) => handleNotify(e)}
        /> */}
      </Link>
    </div>
  );
};

function SkeletonComponent() {
  return (
    <div className={cx("event-item-root")}>
      <div className={cx("img-wrapper")}>
        <Skeleton className={cx("main-image", "placeholder")} />
      </div>
      <div className={styles.wrap}>
        <h1>
          <Skeleton />
        </h1>
        <div className={cx("content")}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    </div>
  );
}

export default EventItem;
